<div class="mfa-container" fxLayout="column">
  <div style="float:right;margin-right:10px;margin-top:10px">
    <button mat-icon-button color="primary" class="m-r-2 " style="float:right;margin-top:10px;margin-right:10px"
      [ngClass]="showHelpIcon ? 'help-icon-click' : ' help-icon'" (click)="ShowHelp()" id='myLauncher'>
      <img [hidden]="hasClass()" src="assets/img/Help.png" style="height: 24px;" alt="Help" />
      <img [hidden]="!hasClass()" src="assets/img/Help_Click.png" style="height: 24px;" alt="Help" />
    </button>
  </div>
  <div fxFlex fxLayout="column" fxLayoutAlign="center center">
    <mat-card class="mat-card-sty" data-loader="mfa-loader">
      <div class="mfa-box">
        <div class="login-header">
          <div class="row" style="justify-content: center;">
            <img src="assets/img/logo/Transcriber_Logo.png" alt="acord_logo">
          </div>
          <div class="login-sub-head">Signing off from Transcriber</div>
        </div>
        <div class="form-group-header">
          <div class="form-group">
            <div class="txt1-sty">All done for now</div>
            <div class="txt2-sty">See you on your next login</div>
          </div>
        </div>       
        <div *ngIf="showMsg">
          <div class="msg-header">
            <img class="logo-img" src="assets/img/logo/SuccessTick.png">
            <div class="suces-styl">You have successfully logged out.</div>
          </div>
        </div>
      </div>
      <div class="form-group-header">
        <div class="form-group linkk">
          <a *ngIf="userType!=='Sso'" class="nav-link" [routerLink]="['/login']">Back to Login</a>
          <a *ngIf="userType==='Sso'" class="nav-link" (click)="goToSSOPage()">Back to Login</a>
        </div>
      </div>
    </mat-card>
  </div>
</div>